import { type ReactNode } from 'react';

interface AuthLayoutProps {
  children: ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex">
      {/* Left side - branding */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-primary via-primary/90 to-primary/70 p-12 flex-col justify-between">
        <div>
          <h2 className="text-2xl font-bold text-white">Ulgebra</h2>
        </div>
        <div className="space-y-4">
          <h1 className="text-4xl font-bold text-white leading-tight">
            Connect your workspace.
            <br />
            Reach your customers.
          </h1>
          <p className="text-lg text-white/80 max-w-md">
            Send SMS, WhatsApp messages, and more directly from your CRM or help desk.
            Integrate with 50+ platforms and 30+ messaging providers.
          </p>
        </div>
        <p className="text-sm text-white/60">
          Trusted by 10,000+ businesses worldwide
        </p>
      </div>

      {/* Right side - form */}
      <div className="flex flex-1 items-center justify-center p-8 bg-background">
        {children}
      </div>
    </div>
  );
}
